const messages = {
  "ui.editableText.cancel.tooltip": "Cancel",
  "ui.editableText.save.tooltip": "Save",
  "ui.editableText.save.tooltip.error.required": "Non-empty value is required",
  "ui.editableText.tooltip": "Edit",
} as const;

export default messages;
